import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingSkeleton from "./components/loading.js";
import ProtectedRoute from "./scripts/protectedRoute";

const Home = React.lazy(() => import("./pages/dashboard/home/home.js"));
const AlarmesDashBoard = React.lazy(
  () => import("./pages/dashboard/alarms/alarmsDashboard.js"),
);
const AlarmesOnline = React.lazy(
  () => import("./pages/dashboard/alarms/alarmsOnline.js"),
);
const AlarmesRealTime = React.lazy(
  () => import("./pages/dashboard/alarms/realtime/alarmsRealtime.js"),
);
const Logs = React.lazy(() => import("./pages/logs/logs"));
const AlarmesCadastro = React.lazy(
  () => import("./pages/register/alarms/alarmsRegister.js"),
);
const Ativos = React.lazy(() => import("./pages/register/assets/assets.js"));
const Usuarios = React.lazy(() => import("./pages/register/users/users.js"));
const Variaveis = React.lazy(
  () => import("./pages/register/variables/variables.js"),
);
const UsuariosGrupo = React.lazy(
  () => import("./pages/register/users/groups/usersGroups.js"),
);
const AtivosGrupo = React.lazy(
  () => import("./pages/register/assets/groups/assetsGroups.js"),
);
const Mapeamento = React.lazy(
  () => import("./pages/register/variables/mappings/mappings.js"),
);
const Perfil = React.lazy(() => import("./pages/profiles/profiles.js"));
const DetalhesGrupo = React.lazy(
  () => import("./pages/dashboard/details/group/groupDetails.js"),
);
const Login = React.lazy(() => import("./pages/login/login.js"));
const EsqueceuSenha = React.lazy(
  () => import("./pages/login/forgotPassword.js"),
);
const SemPermissao = React.lazy(
  () => import("./components/pageNoPermission.js"),
);
const NaoEncontrada = React.lazy(() => import("./components/pageNotFound.js"));

const Modelos = React.lazy(
  () => import("./pages/register/assets/models/models.js"),
);

const AppRoutes = () => (
  <Suspense fallback={<LoadingSkeleton />}>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/esqueceuSenha" element={<EsqueceuSenha />} />
      <Route path="/semPermissao" element={<SemPermissao />} />
      <Route
        exact
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/sumario"
        element={
          <ProtectedRoute>
            <AlarmesDashBoard apenasReconhecidos={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/conectividade"
        element={
          <ProtectedRoute>
            <AlarmesOnline />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/historico"
        element={
          <ProtectedRoute>
            <AlarmesDashBoard apenasReconhecidos={false} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/temporeal"
        element={
          <ProtectedRoute>
            <AlarmesRealTime />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes-cadastro"
        element={
          <ProtectedRoute module="register" action="alarms">
            <AlarmesCadastro />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos"
        element={
          <ProtectedRoute module="register" action="devices">
            <Ativos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <ProtectedRoute module="register" action="users">
            <Usuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/variaveis"
        element={
          <ProtectedRoute module="register" action="variables">
            <Variaveis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute module="actions" action="logsView">
            <Logs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios/grupo"
        element={
          <ProtectedRoute module="register" action="users">
            <UsuariosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos/grupo"
        element={
          <ProtectedRoute module="register" action="devices">
            <AtivosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos/modelos"
        element={
          <ProtectedRoute module="register" action="devices">
            <Modelos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/variaveis/mapeamento"
        element={
          <ProtectedRoute module="register" action="variables">
            <Mapeamento />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <Perfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/grupo/:groupId"
        element={
          <ProtectedRoute>
            <DetalhesGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativo/:deviceLabel"
        element={
          <ProtectedRoute>
            <DetalhesGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NaoEncontrada />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
